"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.db = void 0;

var _app = _interopRequireDefault(require("firebase/app"));

require("firebase/database");

require("firebase/analytics");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//this config is being used for both development and production environment. Though, it is a best practice creating a second project and have two configs: one for production (prodConfig) and another for development (devConfig), so you choose the config based on the environment.
var config = {
  apiKey: 'AIzaSyDvGCfd45wwjqhsb20d7O94GGt9-VvQsEc',
  databaseURL: 'https://gn-watch-app-default-rtdb.europe-west1.firebasedatabase.app',
  authDomain: 'gn-watch-app.firebaseapp.com',
  projectId: 'gn-watch-app',
  storageBucket: 'gn-watch-app.appspot.com',
  messagingSenderId: '135946506727',
  appId: '1:135946506727:web:e1976fc4ddef592a7fed42',
  measurementId: 'G-DH7WHJXKGQ'
};
console.log('initializeApp');

_app.default.initializeApp(config);

_app.default.analytics();

var db = _app.default.database();

exports.db = db;